import React from 'react';
import { Icon, TableColumn, Text, Tooltip, TableRow } from '@upsales/components';
import { FolderType } from '../../AccountFiles';
import { useTranslation } from 'Components/Helpers/translate';
import BemClass from '@upsales/components/Utils/bemClass';
import FolderModal from '../../FolderModal';
import './FolderRow.scss';

type Props = {
	folder: FolderType;
	openFolder: (folderId: number, name: string) => void;
	deleteFolder: (id: number) => void;
	changeNameOfFolder: (id: number, name: string) => void;
};

const FolderRow = ({ folder, openFolder, deleteFolder, changeNameOfFolder }: Props) => {
	const classes = new BemClass('FolderRow');
	const { t } = useTranslation();

	const lang = {
		delete: t('default.delete'),
		rename: t('file.rename')
	};

	return (
		<TableRow
			className={classes.b()}
			key={folder.id}
			onClick={(e: React.MouseEvent<HTMLElement>) => {
				e.stopPropagation();
				openFolder(folder.id, folder.name);
			}}
		>
			<TableColumn>
				<Text>
					<Icon className={classes.elem('folder-icon').b()} name={'folder'} />
					{folder.name}
				</Text>
			</TableColumn>
			<TableColumn className={classes.elem('last-column').b()} align="right">
				<Tooltip className={classes.elem('action-button').b()} title={lang.rename} position="left">
					<div onClick={e => e.stopPropagation()}>
						<FolderModal
							startName={folder.name}
							buttonText={lang.rename}
							onClick={name => {
								changeNameOfFolder(folder.id, name);
							}}
							clickableComponent={onClick => <Icon onClick={onClick} color="grey-6" name="edit" />}
						/>
					</div>
				</Tooltip>
				<Tooltip className={classes.elem('action-button').b()} title={lang.delete} position="left">
					<Icon
						color="grey-6"
						name="trash-o"
						onClick={e => {
							e.stopPropagation();
							deleteFolder(folder.id);
						}}
					/>
				</Tooltip>
			</TableColumn>
		</TableRow>
	);
};

export default FolderRow;
